<span class="text-center linkout" *ngFor="let btnItm of data">
    <a  href="{{btnItm.url}}" target="_blank" class="btn btn-primary">{{btnItm.name || btnItm.title}}</a>
</span>